/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1FormModel } from '../../entities/v1/FormModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1DocumentModelSchema } from './documentModelSchema'
import { z } from 'zod'

export const v1FormModelSchema = z.object({
  children: z.array(z.lazy(() => v1FormModelSchema)).optional(),
  document_objects: z.array(z.lazy(() => v1DocumentModelSchema)),
  form_id: z.number().int(),
  form_is_enabled: z.boolean(),
  form_name: z.string(),
  form_title: z.string(),
}) as unknown as ToZod<V1FormModel>